import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, primitives, semantic, space } from '../../theme/tokens';
import { EntityImage } from '../../components/EntityImage';
import { Badge } from '../../components/Badge';

export const CardBase = styled.div<{ $unavailable?: boolean; $clickable: boolean }>`
  display: flex;
  flex-direction: column;
  background: ${semantic.bg.canvas};
  cursor: ${({ $clickable, $unavailable }) =>
    $clickable ? ($unavailable ? 'not-allowed' : 'pointer') : 'default'};
  opacity: ${({ $unavailable }) => ($unavailable ? 0.55 : 1)};
  transition: transform 0.2s ease;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
    border-radius: 12px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 12px;
  background: ${semantic.bg.surfaceSubtle};
`;

export const Image = styled(EntityImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.tertiary};
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
`;

export const ImageBadge = styled(Badge)`
  position: absolute;
  top: ${space['space-300']};
  left: ${space['space-300']};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
  padding: ${space['space-400']} 0 ${space['space-200']};
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${space['space-300']};
`;

export const Title = styled.h3`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.normal};
  flex: 1;
  min-width: 0;
`;

export const Price = styled.div`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  color: ${semantic.text.primary};
  white-space: nowrap;
`;

export const Time = styled.div`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-300']};
  margin-top: ${space['space-100']};
`;

export const Meta = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;

export const SpotsLeft = styled.span<{ $low: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-200']};
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $low }) => ($low ? semantic.bg.urgencyStrong : semantic.bg.positiveStrong)};
  }
`;

export const SoldOutBadge = styled(Badge)`
  align-self: flex-start;
`;
